// extracted by mini-css-extract-plugin
module.exports = {"header":"bc_bY","root":"bc_cz","backTo":"bc_dX","getLink":"bc_fD","buttonLink":"bc_fF","markdownStyles":"bc_dY"};